import { InputHTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import { FormControlLabel, Paper, Switch, Typography } from "@material-ui/core";
import { DefaultDefinitionGroup, StyledTitle } from "../Styled";
import { DefaultDefinitionProps } from "../types";
import SelectSecuritytDef from "./SelectSecurityDef";

export default function DefaultDefinition({
  value,
  enableDefault,
  onToggle,
  definitions,
  onDefault,
  onBlur,
  error,
  touched,
}: DefaultDefinitionProps) {
  const { t } = useTranslation("securityPolicies");
  const displayError = touched && error;

  return (
    <Paper style={{ padding: "24px 24px 32px 24px" }}>
      <FormControlLabel
        control={
          <Switch
            color="primary"
            checked={enableDefault}
            onChange={onToggle}
            disabled={!definitions.length}
            inputProps={
              {
                "data-testid": "sp-default-toggle",
              } as InputHTMLAttributes<HTMLInputElement>
            }
          />
        }
        label={
          <Typography
            color="textSecondary"
            component="span"
            style={{ fontWeight: "500" }}
          >
            {t("form.defaultDefinition.switch")}
          </Typography>
        }
      />
      {enableDefault && (
        <DefaultDefinitionGroup>
          <StyledTitle>{t("form.defaultDefinition.title")}</StyledTitle>
          <SelectSecuritytDef
            name="defaultDefinition"
            options={definitions}
            onChange={onDefault}
            onBlur={onBlur}
            value={value}
            error={Boolean(displayError)}
            helperText={displayError || ""}
            data-testid="sp-default-definition"
          />
        </DefaultDefinitionGroup>
      )}
    </Paper>
  );
}
